import { render, staticRenderFns } from "./ButtonAccount.vue?vue&type=template&id=d809c780&scoped=true&"
import script from "./ButtonAccount.vue?vue&type=script&lang=js&"
export * from "./ButtonAccount.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAccount.vue?vue&type=style&index=0&id=d809c780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d809c780",
  null
  
)

export default component.exports